<button
  mat-list-item
  [matTooltip]="currentThemeTooltip()"
  [matMenuTriggerFor]="themeMenu"
  data-e2e="navigation__button-theme"
  matTooltipPosition="right"
>
  <mat-icon [svgIcon]="currentOption()?.icon ?? ''"></mat-icon>
</button>
<mat-menu #themeMenu="matMenu">
  @for (option of options; track $index) {
  <button (click)="store.setTheme(option.theme)" mat-menu-item data-e2e="theme-button">
    <mat-icon [svgIcon]="option.icon"></mat-icon>
    {{ option.label }}
  </button>
  }
</mat-menu>
